<template>
  <div class="page">
    <HeaderTop :is_login="false"></HeaderTop>
    <div class="pageContent d-flex d-flex-middle d-flex-center">
      <div class="bmContent">
        <a href="javascript:void(0)" class="back-link" v-if="showCommitment" @click="handleBackToForm">
          <em style="position: relative;top: -1px;">&lt;</em> 返回
        </a>
        <div class="progressBox">
          <BmProgress :steps="steps" :current-step="3" />
        </div>
        <div class="contentBox">
          <!-- 表单视图 -->
          <RegisterInfo 
            v-if="!showCommitment"
            @prev-step="handlePrev" 
            @next-step="handleShowCommitment" 
          />
          <!-- 承诺书视图 -->
          <CommitmentLetter v-else @submit="handleSubmit" />
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import HeaderTop from "@/components/HeaderTop.vue";
import Footer from "@/components/Footer.vue";
import BmProgress from "@/components/bm/bmProgress.vue";
import RegisterInfo from "@/components/bm/registerInfo.vue";
import CommitmentLetter from "@/components/bm/commitmentLetter.vue";

export default {
  name: 'Step3RegisterInfo',
  components: {
    HeaderTop,
    Footer,
    BmProgress,
    RegisterInfo,
    CommitmentLetter
  },
  data() {
    return {
      MOCK_PREFIX: process.env.VUE_APP_MOCK_PREFIX || '',
      showCommitment: false,
      steps: [
        { title: '阅读报名须知' },
        { title: '选择就读地点' },
        { title: '选择报名专业' },
        { title: '注册资料' },
        { title: '提交报名' },
        { title: '缴费' }
      ]
    }
  },
  methods: {
    handlePrev() {
      this.$router.push({ name: 'BmStepSelectMajor' })
    },
    handleShowCommitment() {
      this.showCommitment = true
    },
    handleBackToForm() {
      this.showCommitment = false
    },
    handleSubmit() {
      this.$router.push({ name: 'BmStepSubmitRegistration' })
    },
  }
}
</script>

<style lang="scss" scoped>
.page {
  min-height: 100vh;
  position: relative;
}

.pageContent {
  padding: 20px;
  min-height: calc(100vh - 200px);
  margin-top: 70px;
  background: url('../../assets/bm/bmBg.png') no-repeat center center;
  background-size: 100% 100%;
}

.bmContent {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  padding: 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.back-link {
  margin-bottom: 20px;
  display: inline-block;
  color: #767676;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
  text-decoration: none;
  transition: color 0.3s;

  &:hover {
    color: #40a9ff;
    text-decoration: underline;
  }
}

.progressBox {
  width: 100%;
  margin-bottom: 20px;
}

.contentBox {
  width: 1000px;
  margin: 0 auto;
  border-top: 1px solid #E9EFF9;
}
</style>
